import { urlWithParams } from '@marketplace-web/browser/url-util'

export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const OFFER_REQUEST_ACCEPT_URL = (transactionId: number, offerRequestId: string) =>
  `/transactions/${transactionId}/offer_requests/${offerRequestId}/accept`
export const OFFER_REQUEST_REJECT_URL = (transactionId: number, offerRequestId: string) =>
  `/transactions/${transactionId}/offer_requests/${offerRequestId}/reject`
export const SERVICE_FEE_HELP_URL = '/help/342'
